import {esES} from '@material-ui/core/locale';
import {createTheme} from '@material-ui/core/styles';
import {button} from 'assets/theme/button';
import {palette} from 'assets/theme/palette';
import * as colors from './colors';
import {typography} from './typography';
import {transparent} from './colors';

export const theme = createTheme(
    {
        palette,
        typography,
        overrides: {
            ...button,
            MuiFormHelperText: {
                root: {
                    color: colors.neutrals.A40,
                },
            },
            MuiRadio: {
                colorPrimary: {
                    color: colors.neutrals.A40,
                    maxWidth: 1,
                    maxHeight: 1,
                    backgroundColor: transparent,
                    borderRadius: 1,
                    border: `solid 0px ${colors.primary.A20}`,
                    marginLeft: '.25rem !important',
                    '&:hover': {
                        backgroundColor: transparent,
                    },
                    '&$checked': {
                        maxWidth: 1,
                        maxHeight: 1,
                        color: colors.primary.A20,
                        backgroundColor: transparent,
                        borderRadius: 1,
                        border: `solid 0px ${colors.primary.A20}`,
                    },
                },
                colorSecondary: {
                    color: colors.neutrals.A40,
                    maxWidth: 1,
                    maxHeight: 1,
                    backgroundColor: transparent,
                    borderRadius: 1,
                    border: `solid 0px ${colors.primary.A20}`,
                    marginLeft: '.25rem !important',
                    '&:hover': {
                        backgroundColor: transparent,
                    },
                    '&$checked': {
                        maxWidth: 1,
                        maxHeight: 1,
                        color: colors.primary.A20,
                        backgroundColor: transparent,
                        borderRadius: 1,
                        border: `solid 0px ${colors.primary.A20}`,
                    },
                },
            },
        },
        spacing: (factor) => `${0.25 * factor}rem`,
    },

    esES
);
